module.exports = __webpack_public_path__ + "img/favorite_ing.29c1f6c9.png";